import MatchedMap from 'utilities/src/matchedMap';

import { InputThemeEnum, type InputThemeProps } from '../../../utils/themes';

/**
 * MessageError Common Classes
 */

const messageErrorWrapperClasses = 'flex items-center gap-1';

const messageErrorTextClasses = 'font-medium paragraph-xs';

/**
 * MessageError Theme Classes
 */

const messageErrorTextColorClassesMap = new MatchedMap([
  [InputThemeEnum.Dark, 'text-danger-500'],
  [InputThemeEnum.Light, 'text-danger-700'],
]);

const messageErrorIconColorClassesMap = new MatchedMap([
  [InputThemeEnum.Dark, 'fill-danger-500'],
  [InputThemeEnum.Light, 'fill-danger-700'],
]);

/**
 * Blog Theme
 */

const inputMessageErrorBlogTheme = ({ inputTheme }: Pick<InputThemeProps, 'inputTheme'>) => ({
  messageErrorWrapperThemeClasses: messageErrorWrapperClasses,
  messageErrorTextThemeClasses: messageErrorTextClasses,
  messageErrorTextColorThemeClasses: messageErrorTextColorClassesMap.get(InputThemeEnum[inputTheme]),
  messageErrorIconColorThemeClasses: messageErrorIconColorClassesMap.get(InputThemeEnum[inputTheme]),
});

export default inputMessageErrorBlogTheme;
